import { UiEvent } from './utils/ui-event';
import { GlobalClickTrackingHomepage } from './tracking/global-click-tracking-homepage';
import { GlobalClickTrackingLandingpage } from './tracking/global-click-tracking-landingpage';
import { GlobalClickTrackingEditorial } from './tracking/global-click-tracking-editorial';
import { ScrollTracking } from './tracking/scroll-tracking';
import { SwipeTracking } from './tracking/swipe-tracking';

const initGlobalUiTracking = () => {
	switch (UiEvent.getCategory()) {
		case 'homepage':
			new GlobalClickTrackingHomepage();
			return;
		case 'landing-page':
			new GlobalClickTrackingLandingpage();
			return;
		default:
			new GlobalClickTrackingEditorial();
			new ScrollTracking();
			new SwipeTracking();
	}
};

if (/complete|interactive|loaded/.test(document.readyState)) {
	initGlobalUiTracking();
} else {
	document.addEventListener('DOMContentLoaded', () => initGlobalUiTracking());
}
